<template>
  <div class="card position-relative">
    <mainHeader title="Withdrawal"></mainHeader>
    <div style="padding: 0 12px;">
    <LoadingOverlay :show="loading" />
    <div class="card-body">
      <div class="mb-3">
        <label for="currency" class="form-label">Mention a currency</label>
        <input
          type="number"
          class="form-control"
          id="currency"
          placeholder="Please enter the withdrawal quantity"
          v-model="form.currency"
        />
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Withdraw password</label>
        <input
          type="password"
          class="form-control"
          id="password"
          placeholder="Please enter withdraw password"
          v-model="form.password"
        />
      </div>
      <div class="mb-3">
        <label for="charges" class="form-label">Charges</label>
        <input
          type="text"
          class="form-control"
          id="charges"
          v-model="form.charges"
          disabled
        />
      </div>
      <button class="btn btn-primary" type="button" @click="submit">
        Submit
      </button>
    </div>
    </div>
  </div>
</template>

<script>
import { withdrawal } from "@/apis/wallet";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { message } from "@/utils/message";
import mainHeader from '@/components/mainHeader.vue';
export default {
  data() {
    return {
      loading: false,
      form: {
        currency: "",
        password: "",
        charges: "Charges0%",
      },
    };
  },
  components: {
    LoadingOverlay,
    mainHeader
  },
  methods: {
    async submit() {
      console.log(this.form);
      this.loading = true;
      try {
        const params = {
          amount: this.form.currency,
          pay_pwd: this.form.password,
        };
        const res = await withdrawal(params);
        this.loading = false;
        console.log(res);
        if (res.code === 0) {
          message.success("Withdrawal successfully");
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
